import { useEffect, useState } from 'react';
import { listCategories } from 'api/catalog';

/** Shop categories for navigation. [] until loaded (or if loading fails). */
export default function useCategories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    let active = true;
    listCategories()
      .then(({ value }) => active && setCategories(value || []))
      .catch(() => active && setCategories([]));
    return () => {
      active = false;
    };
  }, []);
  return categories;
}
